<template>
  <div class="lookup-relationship-box">
    <div class="lookup-select">
      <el-select
        v-model="selectId"
        style="flex: 1;"
        v-bind="$attrs"
        filterable
        clearable
        :placeholder="placeholder"
        :disabled="disabled"
        :size="size"
      >
        <el-option
          v-for="item in mainFieldList"
          :key="item.aPaaS_SequenceId"
          :label="item.mainField"
          :value="item.aPaaS_SequenceId"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import {HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'
import {lookupRelationshipProps} from '../index.js'
import {requestMasterRelationValueObject} from '../request.js'

export default {
  name: 'master-edit-relationship',
  props: lookupRelationshipProps,
  data () {
    return {
      selectId: '',
      mainFieldList: [],
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        const type = Object.prototype.toString.call(val)

        if (type === '[object Object]') {
          this.selectId = val.id
          return
        }

        this.selectId = val
      }
    },
    selectId: {
      deep: true,
      immediate: true,
      handler (val) {
        this.$emit('change', val)
      }
    }
  },
  computed: {
    headerParams () {
      const {relateObjectApiName} = this.params
      return {
        [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
        [HEADER_PARAMS_KEYS.objectApiName]: relateObjectApiName
      }
    }
  },
  mounted () {
    this.getValueObject()
  },
  methods: {
    // 获取值对象
    async getValueObject () {
      const params = {
        tenantType: this.tenantType,
        relateObjectApiName: this.params.relateObjectApiName
      }
      if (!this.params.relateObjectApiName) {
        return
      }
      this.mainFieldList = await requestMasterRelationValueObject(params, this.headerParams)
    }
  }
}
</script>

<style scoped lang="scss">
.lookup-relationship-popup {
  ::v-deep .list-search {
    border: 1px solid #D6DFFF !important;
    border-radius: 8px !important;
    box-shadow: 0 0 8px rgba(57, 121, 201, 0.14) !important;
  }
}

.lookup-relationship-box {
  display: inline-block;
  width: 100%;
}

.lookup-select {
  display: flex;
  align-items: center;
  height: 32px;
}
</style>
